import { render, staticRenderFns } from "./view-modal.vue?vue&type=template&id=4484c4fa&"
import script from "./view-modal.vue?vue&type=script&lang=js&"
export * from "./view-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports